"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var Typography = _styledComponents["default"].p.withConfig({
  displayName: "Tagline__Typography",
  componentId: "sc-1lski3x-0"
})(["font-size:calc( 20.25px + (20.25 - 18) * ((100vw - 300px) / (1600 - 300)) );margin-left:auto;margin-right:auto;max-width:100%;width:42rem;"]);
var Tagline = function Tagline(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(Typography, null, children);
};
Tagline.propTypes = {
  children: _propTypes["default"].string.isRequired
};
var _default = Tagline;
exports["default"] = _default;